import React from "react";
import AdminHeader from "../../../components/admin/AdminHeader";
import { AdminFooter } from "../../../components/admin/AdminFooter";
import AdminSubscriptionPageEdit from "../../../views/admin/subscription";

const AdminSubscriptionList = () => {
  window.scrollTo(0, 0);

  return (
    <div>
      <AdminHeader />
        <AdminSubscriptionPageEdit />
      <AdminFooter />
    </div>
  );
};

export default AdminSubscriptionList;
